export default function diagnosticError(errorMessage: string): Error {
  const error: Error = new Error(errorMessage);

  error.name = 'Invariant violation error';

  return error;
}
